import React, { MutableRefObject, useRef, useState } from "react";

import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";

import { handleKeyMoveFirstChildElement, handleKeyMoveList } from "../../../utils/moveFunctions";
import CustomModalHeader from "../../custom-modal-elements/custom-modal-header";
import CustomSpinner from "../../custom-spinner/custom-spinner";
import { TooltipHOC } from "../../gt-tooltip/gt-tooltip-hoc";
import { useGlobalSearch } from "../hook/useGlobalSearch";
import PrettyCell from "../../prime-data-table/body-components/pretty-cell/pretty-cell";
import { ISearchData } from "../interface";
import { NoResults } from "./noResults";
import Icon from "../../icon";
import { SearchResult } from "./search-result";

interface IModalGlobalSearchProps {
    isModalOpen: boolean;
    closeModal: () => void;
    inputRef: MutableRefObject<HTMLInputElement | null>;
    navbarInput: string;
    searchData: ISearchData;
}
export const ModalGlobalSearch = ({ isModalOpen, closeModal, inputRef, navbarInput, searchData }: IModalGlobalSearchProps) => {
    const [inputValue, setInputValue] = useState<string>(navbarInput);

    const ref = useRef<HTMLDivElement | null>(null);

    const handleChange = (e) => {
        const { value } = e.target;
        setInputValue(value);
    };

    const { results, isLoading } = useGlobalSearch({ input: inputValue });

    return (
        <Modal isOpen={isModalOpen} toggle={closeModal} fade>
            <CustomModalHeader closeModal={closeModal} name="Search" />
            <ModalBody>
                <form className="global-search" action="#" onSubmit={(e) => e.preventDefault()}>
                    <div role="button" className="global-search-icon">
                        <Icon name="search" />
                    </div>
                    <div className="search-input-container">
                        <input
                            type="search"
                            className="modal-search"
                            placeholder="Type to search..."
                            ref={inputRef}
                            value={inputValue}
                            onChange={handleChange}
                            onKeyDown={(e) => handleKeyMoveFirstChildElement(e, ref)}
                        />
                    </div>
                </form>
                {isLoading ? (
                    <CustomSpinner />
                ) : Object.values(results || searchData).every((value) => !value.length) ? (
                    <NoResults />
                ) : (
                    <div className="results" ref={ref}>
                        {Object.entries(results || searchData).map(([key, value], index) => (
                            <SearchResult model={key} value={value} key={index} onLink={closeModal} />
                        ))}
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};
